import React from 'react';
import withRipple from "../hocs/withRipple";

import { FilterButtonWrap, Icon, RippleContainer } from "./styles";







export const FilterButton = ({
  children,
  className = '',
  onClick = () => void 0 }) =>
{
  const RippleEffect = withRipple(RippleContainer);

  return /*#__PURE__*/(
    React.createElement(FilterButtonWrap, {
      testId: "filter-button",
      className: className,
      onClick: onClick,
      defaultHoverBehavior: true },

    children, /*#__PURE__*/
    React.createElement(Icon, null), /*#__PURE__*/
    React.createElement(RippleEffect, null)));


};